(() => {
  document.querySelectorAll('[data-dobel-question-open]').forEach((trigger) => {
    if (trigger.dataset.dobelQuestionReady) return;
    trigger.dataset.dobelQuestionReady = 'true';
    const dialog = document.getElementById(trigger.dataset.dobelQuestionOpen);
    if (!dialog) return;
    let returnFocus = null;
    const close = () => {
      if (dialog.open) dialog.close();
    };

    trigger.addEventListener('click', () => {
      returnFocus = trigger;
      dialog.showModal();
      document.body.classList.add('dobel-question-dialog-open');
      requestAnimationFrame(() => dialog.querySelector('input:not([type="hidden"])')?.focus());
    });
    dialog.querySelector('[data-dobel-question-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('dobel-question-dialog-open');
      returnFocus?.focus();
    });
    if (dialog.querySelector('[data-dobel-question-success], [role="alert"]')) {
      dialog.showModal();
      document.body.classList.add('dobel-question-dialog-open');
    }
  });
})();